//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isPlainObject from 'lodash/isPlainObject';
import isEmpty from 'lodash/isEmpty';
import ProductDescription from '~/components/molecules/Product/ProductDescription.vue';
import ProductCharacteristics from '~/components/molecules/Product/ProductCharacteristics.vue';
import ProductMedia from '~/components/molecules/Product/ProductMedia.vue';
export default {
  name: 'ProductInformation',
  components: {
    ProductCharacteristics,
    ProductDescription,
    ProductMedia
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasCharacteristics() {
      return isPlainObject(this.product.parameters);
    },

    hasDescriptions() {
      return !isEmpty(this.product.additionalInformation.additionalContent) || !isEmpty(this.product.description.main) || !isEmpty(this.product.additionalInformation.infoCompDescription) || !isEmpty(this.product.description.line) || !isEmpty(this.product.line);
    },

    hasMediaOrLogos() {
      return !isEmpty(this.product.additionalInformation.video) || !isEmpty(this.product.additionalInformation.specificityLogo);
    }

  }
};